import React, { useMemo } from 'react';
import { DetailsTabs } from 'features/sendouts/components/shared';
import strings from 'strings';

import { SendoutAttachmentsTabContent } from './SendoutAttachmentsTabContent';

const buildTabs = ({ sendoutId }) => [
  {
    id: 'Interviews',
    label: strings.sendoutsV2.drawers.tabs.interviews.title,
    view: <div>Interviews Content</div> // TODO: Create Interviews Tab Content
  },
  {
    id: 'Attachments',
    label: strings.sendoutsV2.drawers.tabs.attachments.title,
    view: <SendoutAttachmentsTabContent sendoutId={sendoutId} />
  },
  {
    id: 'Emails',
    label: strings.sendoutsV2.drawers.tabs.emails.title,
    view: <div>Emails Content</div> // TODO: Create Emails Tab Content
  },
  {
    id: 'ActivityLogs',
    label: strings.sendoutsV2.drawers.tabs.activityLogs.title,
    view: <div>Activity Logs Content</div> // TODO: Create Activity Logs Tab Content
  },
  {
    id: 'Notes',
    label: strings.sendoutsV2.drawers.tabs.notes.title,
    view: <div>Notes</div> // TODO: Create Notes Tab Content
  }
];

export const SendoutDetailsTabs = ({ sendoutId }) => {
  const tabs = useMemo(() => buildTabs({ sendoutId }), [sendoutId]);

  return <DetailsTabs initialTab={tabs[0].id} tabs={tabs} />;
};
